import React from 'react'
import './Weather.css'

function Weather() {
  return (
    <div className="Weather">
        <div className="weather__header">
            <div className="weather__headerTitle">
                <h1>TODAY'S FORECAST</h1>
            </div>
            <div className="weather__headerLocation">
                <input className="weather__cityInput"
                type="text"
                placeholder="Search city. . . "
                required
                />
            </div>
        </div>
        <div className="weather__content">
            <h1>Weather</h1>
            <h1>Temperature</h1>
            <div className="weather__description">
                <h1>Icon</h1>
                <img src="/images/weather-icons/icons8-clouds-100.png" alt="Cloud Icon"
                style={{width:"150px"}}
                />
            </div>
            <h1>Humidity</h1>
            <h1>Wind</h1>
        </div>
    </div>
  )
}

export default Weather